import React from 'react';
import { Grid, Card, CardContent, Typography, Box, Avatar } from '@mui/material';
import WorkIcon from '@mui/icons-material/Work';
import PsychologyIcon from '@mui/icons-material/Psychology';
import BusinessIcon from '@mui/icons-material/Business';
import GroupsIcon from '@mui/icons-material/Groups';
import BrushIcon from '@mui/icons-material/Brush';
import { PersonalityTypes } from '../Results';

const TypeCard = ({ type, icon, color, description, keywords }) => (
  <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
    <CardContent>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Avatar sx={{ bgcolor: color, mr: 2 }}>
          {icon}
        </Avatar>
        <Typography variant="h6" component="div">
          {type}
        </Typography>
      </Box>
      <Typography variant="body1" color="text.secondary" paragraph>
        {description}
      </Typography>
      <Typography variant="subtitle2" color="primary" gutterBottom>
        Mots-clés associés:
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {keywords.map((keyword, index) => (
          <Box
            key={index}
            sx={{
              bgcolor: `${color}15`,
              color: 'text.primary',
              px: 1,
              py: 0.5,
              borderRadius: 1,
              fontSize: '0.875rem'
            }}
          >
            {keyword}
          </Box>
        ))}
      </Box>
    </CardContent>
  </Card>
);

const TypeExplanation = () => {
  const types = {
    REALISTE: {
      ...PersonalityTypes.REALISTE,
      keywords: ['Manuel', 'Technique', 'Pratique', 'Concret', 'Physique']
    },
    INVESTIGATEUR: {
      ...PersonalityTypes.INVESTIGATEUR,
      keywords: ['Analyse', 'Recherche', 'Complexité', 'Observation', 'Résolution de problèmes']
    },
    ARTISTIQUE: {
      ...PersonalityTypes.ARTISTIQUE,
      keywords: ['Créativité', 'Expression', 'Innovation', 'Originalité', 'Imagination']
    },
    SOCIAL: {
      ...PersonalityTypes.SOCIAL,
      keywords: ['Entraide', 'Communication', 'Collaboration', 'Enseignement', 'Service']
    },
    ENTREPRENEUR: {
      ...PersonalityTypes.ENTREPRENEUR,
      keywords: ['Leadership', 'Persuasion', 'Initiative', 'Gestion', 'Négociation']
    },
    CONVENTIONNEL: {
      ...PersonalityTypes.CONVENTIONNEL,
      keywords: ['Organisation', 'Précision', 'Méthode', 'Structure', 'Planification']
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom align="center" sx={{ mb: 4 }}>
        Les Types de Personnalité Holland
      </Typography>
      <Grid container spacing={3}>
        {Object.entries(types).map(([type, data]) => (
          <Grid item xs={12} md={6} key={type}>
            <TypeCard
              type={type}
              icon={React.cloneElement(data.icon, { sx: { fontSize: 24 } })}
              color={data.color}
              description={data.description}
              keywords={data.keywords}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default TypeExplanation; 